import { FunctionComponent, SVGProps } from 'react';

import IconUser from '../components/icons/user.svg';
import IconLock from '../components/icons/lock.svg';
import IconPayment from '../components/icons/payment.svg';
import IconInvoice from '../components/icons/invoice.svg';
import IconPlan from '../components/icons/plan.svg';
import IconDownload from '../components/icons/download.svg';
import IconNotification from '../components/icons/notification.svg';
import IconDevice from '../components/icons/device.svg';
import IconParentalControl from '../components/icons/parental-control.svg';
import IconSupport from '../components/icons/help.svg';
import IconSearch from '../components/icons/search.svg';

type Sections = Array<{
    title?: string;
    items: Array<{
        label: string;
        link: string;
        icon: FunctionComponent<SVGProps<SVGSVGElement>>;
        isExternal?: boolean;
        filter?: boolean;
    }>;
}>;

export const SECTIONS = (isCreate?: boolean): Sections => [
    {
        title: 'Profile',
        items: [
            { label: 'Personal Info', link: './personal-info', icon: IconUser },
            { label: 'Change Password', link: './change-password', icon: IconLock },
        ],
    },
    {
        title: 'Subscription',
        items: [
            { label: 'Payment Method', link: './payment', icon: IconPayment },
            { label: 'Invoices', link: './invoices', icon: IconInvoice },
            { label: 'Available Plans', link: './plan', icon: IconPlan },
        ],
    },
    {
        items: [{ label: 'Downloads', link: './downloads', icon: IconDownload }],
    },
    {
        title: 'Settings',
        items: [
            { label: 'Notifications', link: './notifications', icon: IconNotification },
            { label: 'Device Management', link: './devices', icon: IconDevice },
            { label: 'Parental Control', link: './parental-control', icon: IconParentalControl, filter: !isCreate },
            { label: 'Search Settings', link: './search-settings', icon: IconSearch, filter: !isCreate },
        ],
    },
    {
        items: [{ label: 'Support', link: './support', icon: IconSupport, isExternal: true }],
    },
];
